import React from 'react';

import cn from 'classnames';
import { NavLink } from 'react-router-dom';

import IconFemtasy from 'components/IconFemtasy';
import { FemtasyIcon } from 'components/IconFemtasy/iconsType';
import Message from 'components/Message';
import NestedLink from 'components/NestedLink';
import Typography from 'components/Typography';

interface TabBarItemProps {
  activeIcon: FemtasyIcon;
  icon: FemtasyIcon;
  otherMatchingUrls?: string[];
  text: string;
  to: string;
}

const TabBarItem = ({
  activeIcon,
  icon,
  otherMatchingUrls,
  text,
  to,
}: TabBarItemProps) => {
  const matchesUrl = [to, ...(otherMatchingUrls || [])].some((url) => {
    // The code below splits the path of the URL. We need to check two
    // cases, the URL containing or not the locale.

    const splittedUrl = window.location.pathname
      .split('/')
      .filter((element) => element);

    // splittedUrl only has two values:
    // locale and path. e.g ["de", "browse"]
    // we only need to check for path.
    // when there is no locale the array only has path.
    switch (splittedUrl.length) {
      case 1:
        return url.includes(splittedUrl[0]);
      default:
        return url.includes(splittedUrl[1]);
    }
  });

  return (
    <NestedLink
      activeClassName="TabBar__item--active"
      className="TabBar__item flex flex-1 flex-col justify-center text-center"
      Component={NavLink}
      isActive={() => matchesUrl}
      to={to}
    >
      <IconFemtasy
        color={matchesUrl ? 'white' : 'white-opacity'}
        icon={matchesUrl ? activeIcon : icon}
      />
      <Typography
        variant="small-thin"
        color={matchesUrl ? 'white' : 'white-opacity'}
      >
        <span
          className={cn('TabBar__item-text', {
            'font-bold leading-4 font-sans px-0.5 bg-primary rounded text-white':
              matchesUrl,
          })}
        >
          <Message message={{ id: text }} />
        </span>
      </Typography>
    </NestedLink>
  );
};

export default TabBarItem;
